module.exports = __webpack_public_path__ + "assets/img/wallpaper-narayan.85082038.png";